export default __webpack_public_path__ + "static/couple-tablet-7fc15148406cd5d4b5d2bacd95480b0d.jpg";